<template>
  <v-app :class="prefix">
    <v-app-bar
      fixed
      :color="maincolor"
      dark
      flat>
      <v-toolbar-title>{{ titlepage }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- public -->
      <v-btn
        icon
        @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main class="my-14 my-md-16">
      <router-view></router-view>
    </v-main>
    <!-- left drawer - public -->
    <v-navigation-drawer
      v-if="useremail === ''"
      v-model="drawer"
      temporary
      fixed
      right>
      <v-list
        shaped>
        <v-list-item-group
          v-model="group"
          active-class="blue--text text--darken-4">
          <v-list-item
            v-for="(item, i) in pubmenu"
            :key="i"
            link
            :to="item.to"
            exact>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- left drawer - private -->
    <v-navigation-drawer
      v-if="useremail !== ''"
      v-model="drawer"
      temporary
      fixed
      right>
      <v-list-item-group
        v-model="group"
        active-class="blue--text text--darken-4">
        <v-list
          shaped>
          <v-list-item
            v-for="(item, i) in menunavshow"
            :key="i"
            link
            :to="item.to"
            exact>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
      <template v-slot:append v-if="tokenscr">
        <div class="pa-2">
          <v-btn color="error" tile depressed block @click="doLogout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- navigasi bawah - private -->
    <v-bottom-navigation
      v-if="useremail !== ''"
      fixed
      dark
      :background-color="maincolor">
      <v-btn
        :to="{ name: 'Home' }"
        exact>
        <span>Home</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        :to="{ name: 'SKDosen' }"
        exact>
        <span>S.Keputusan</span>
        <v-icon>mdi-email-check</v-icon>
      </v-btn>
      <v-btn
        :to="{ name: 'STDosen' }"
        exact>
        <span>S.Tugas</span>
        <v-icon>mdi-email-arrow-right</v-icon>
      </v-btn>
      <v-btn
        :to="{ name: 'SLDosen' }"
        exact>
        <span>S.Lainnya</span>
        <v-icon>mdi-email-sync</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <!-- footer - public -->
    <v-footer
      v-if="useremail === ''"
      dark
      :color="maincolor"
      absolute>
      <v-col
        class="text-center"
        cols="12">
        &copy; {{ new Date().getFullYear() }} - <strong> Politeknik Negeri Bali</strong>
        <div>
          <code>{{ appname }}</code>
        </div>
      </v-col>
    </v-footer>
    <!-- notification -->
    <notifications class="my-2"/>
    <!-- dialog -->
    <v-dialog
      v-model="dialogfavorite"
      width="300">
      <v-card>
        <v-card-title class="headline">
          Delete confirmation
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete your favorite glossary?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            small
            tile
            @click="resetFavorite()">
            Delete
          </v-btn>
          <v-btn
            color="success"
            small
            tile
            @click="dialogfavorite = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import qs from 'qs';
import { Plugins } from '@capacitor/core';
const { App } = Plugins;

// App.addListener('backButton', () => {
//     App.exitApp();
// });

export default Vue.extend({
  name: 'App',
  components: {
  },
  data: () => ({
    appname: process.env.VUE_APP_NAME,
    apptitle: process.env.VUE_APP_TITLE,
    appsubtitle: process.env.VUE_APP_SUBTITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    darktheme: process.env.VUE_APP_DARK,
    rightDrawer: false,
    drawer: false,
    group: null,
    notif: [],
    pubmenu: [
      {
        title: 'Login',
        to: { name: 'Login' },
        icon: 'mdi-login-variant',
      },
      {
        title: 'About',
        to: { name: 'About' },
        icon: 'mdi-information',
      },
    ],
    menunav: [
      {
        title: 'Data Kamus',
        icon: 'description',
        to: { name: 'KamusAdmin' },
        role: ['admin'],
      },
      {
        title: 'Change Password',
        icon: 'lock_open',
        to: { name: 'Changepassword' },
        role: ['admin', 'dosen'],
      },
    ],
    menunavshow: [],
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    loading: {
      berita: false,
    },
    btndash: 'Home',
    dialogfavorite: false,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
      'titlepage',
    ]),
  },
  mounted() {
    // check tokensrc
    if (this.tokenscr && this.tokenscr !== '') {
      this.checkTokenscr();
    }
    // update menu if not watch
    this.menuByRole();
    // notif
    // this.getNotifikasi();
    // static data
    this.getStaticData();
  },
  methods: {
    closeApp() {
      // console.log(App);
      try {
        App.exitApp();
      } catch (error) {
        console.log('white error!');
      }
    },
    resetFavorite() {
      this.$store.commit('RESET_FAV');
      this.dialogfavorite = false;
    },
    resetHistory() {
      this.$store.commit('RESET_HISTORY');
    },
    menuByRole() {
      // dashboard btn
      if (this.userrole === 'admin') {
        this.btndash = 'Home';
      } else if (this.userrole === 'dosen') {
        this.btndash = 'Home';
      } else {
        this.btndash = 'Home';
      }
      // menu nav
      this.menunavshow = [];
      // console.log(this.userrole);
      for (const row of this.menunav) {
        if (this.userrole && this.userrole !== '') {
          if (row.role.indexOf(this.userrole) >= 0) {
            this.menunavshow.push(row);
          }
        } else {
          if (row.role.indexOf('public') >= 0) {
            this.menunavshow.push(row);
          }
        }
      }
    },
    getNotifikasi() {
      this.notif = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/surat/',
            {
              params: {
                status: 'request',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.notif = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkTokenscr() {
      this.axios
        .post(
          this.api + '/api/checktoken',
          qs.stringify(
            {
              token: this.tokenscr,
            },
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.tokenscr,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === true) {
              this.doLogout();
            }
          }
        })
        .catch((error) => {
          this.doLogout();
        });
    },
    doLogout() {
      this.$store.commit('AUTH_LOGOUT');
      this.$router.push({ name: 'Login' });
    },
    getStaticData() {
      this.loading.static = true;
      this.axios
        .post(
          this.api + '/public/' + this.prefix,
          qs.stringify(
            this.login,
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === false) {
              this.$store.commit('SET_STATICDATA', resdata.data);
            } else {
              console.log('');
            }
          } else {
            console.log('Internal services error!');
          }
          this.loading.static = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.static = false;
        });
    },
  },
  watch: {
    userrole(val) {
      this.menuByRole();
    },
    tokenscr(val) {
      // this.getNotifikasi();
    },
  },
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $main-color: #216185;
  .title-style-pnb{
    font-family: 'Nunito' !important;
    color: $main-color !important;
    font-weight: bold;
    line-height: normal !important;
  }
  .title-style-pnb{
    font-size: 26px;
  }
  .subtitle-style-pnb{
    font-size: 16px;
  }
  .main-style-slide{
    color: $main-color !important;
  }
  .foot-list-icon{
    width: 40px;
  }
  .foot-list-content{
    display: table-cell;
    vertical-align: top;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .class-cursor{
    cursor: pointer;
  }
</style>
